import { BYTES_IN_MB } from "@constants";
import { UploadFile } from "@mui/icons-material";
import { Paper, Stack, Typography } from "@mui/material";
import { theme } from "@theme";
import { FileRejection, useDropzone } from "react-dropzone";

export const MAX_FILE_SIZE = 500 * BYTES_IN_MB;
const ACCEPTED_FILE_TYPES = {
  "application/json": [".json"],
  "video/mp4": [".mp4", ".mov"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
};
const APPROVED_FILES = `json, mp4, mov, png or jpg (max. ${MAX_FILE_SIZE / BYTES_IN_MB}MB)`;

interface DropzoneProps {
  handleDropFiles: (
    acceptedFiles: File[],
    rejectedFiles: FileRejection[],
  ) => void;
}

const Dropzone = ({ handleDropFiles }: DropzoneProps) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDropFiles,
    accept: ACCEPTED_FILE_TYPES,
    maxSize: MAX_FILE_SIZE,
    multiple: true,
  });

  return (
    <Stack>
      <Typography variant="subtitle1">
        Upload: Scorecard, Plan Walkthrough & Images
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Need to upload a revised file? Remove the existing one first.
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          ":hover": { backgroundColor: theme.palette.action.hover },
          borderStyle: "dashed",
          borderWidth: 1,
          cursor: "pointer",
          marginTop: 2,
        }}
        {...getRootProps()}
      >
        <Stack alignItems="center" justifyContent="center" height="152px">
          <input {...getInputProps()} data-testid="drag-and-drop-box" />
          <UploadFile
            style={{
              color: theme.palette.primary.main,
              fontSize: 24,
              marginBottom: "12px",
            }}
          />
          <Stack direction="row" gap={1}>
            <Typography
              variant="body1"
              sx={{
                textDecoration: "underline",
                color: theme.palette.primary.main,
              }}
            >
              Click to upload{" "}
            </Typography>
            <Typography variant="body1">or drag and drop</Typography>
          </Stack>

          <Typography
            variant="body2"
            sx={{ color: theme.palette.text.secondary }}
          >
            {APPROVED_FILES}
          </Typography>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default Dropzone;
